import React, { memo } from 'react'
import { BodyText, HeadingText, Link } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { PYPL_SECURITY_SETTINGS } from '../../constants/constants'

const SecurityOptions = memo((props) => (
  <div className="privacyHub-model">
    <HeadingText
      id="securityOptionsHeader"
      className="privacyHub-model-heading"
      size="lg"
    >
      <Message id="privacyhub.securityoptions.header" />
    </HeadingText>
    <BodyText size="lg" className="privacyHub-model-content">
      <Message
        id="privacyhub.securityoptions.component.desc"
        link={(innerMessage) => (
          <Link
            id="securitySettingsLink"
            name="security_settings"
            href={PYPL_SECURITY_SETTINGS}
          >
            {innerMessage}
          </Link>
        )}
      />
    </BodyText>

    {props.content(props.keys && props.keys.securityoptions)}
  </div>
))

//not sure - same for 4 pages
SecurityOptions.displayName = 'SecurityOptions'

export default SecurityOptions
